export default {
  enterpriseName: [
    {
      required: true,
      message: '请填写企业名称',
      trigger: 'blur',
    },
  ],
  brandNum: [
    {
      required: true,
      message: '请填写品牌数量',
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        const pattern = /^[1-9]\d*$/
        if (!pattern.test(value)) {
          callback(new Error('品牌数量必须为正整数'))
        }
        callback()
      },
      trigger: 'change',
    },
  ],
  keywordNum: [
    {
      required: true,
      message: '请填写品牌关键词数量',
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        const pattern = /^[1-9]\d*$/
        if (!pattern.test(value)) {
          callback(new Error('关键词数量必须为正整数'))
        }
        callback()
      },
      trigger: 'change',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/pages/index/views/companyManage/rules.js